module.exports = __webpack_public_path__ + "img/tk-link.04456ee6.png";